import React, { useState } from "react";
import { DeleteIcon, EditIcon } from "../components/Shared/TableActionIcons";

import { useDispatch, useSelector } from "react-redux";
import CustomPagination from "../components/Shared/CustomPagination";
import {
  deleteBuisness,
  GetBusinessesList,
} from "../store/slices/BusinessSlice";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import BusinessModal from "./BusinessModal";
import SharedButton from "../components/Shared/SharedButton";
import ConfirmationModal from "../components/Shared/ConfirmationModal";
import { FiTrash2 } from "react-icons/fi";
import TableLoading from "../components/Shared/TableLoading";
import CustomTable from "../components/Shared/CustomTable";
import { useNavigate } from "react-router-dom";
export default function BusinessTable({ data, loading, onPageChange, onRefresh }) {
  const dispatch = useDispatch();
  const lang = i18next.language;
  const [selectedData, setSelectedData] = useState(null);
  const [confirmationDialogVisible, setConfirmationDialogVisible] =
    useState(false);
  const handlePageChange = (newPage, newRowsPerPage) => {
    if (onPageChange) {
      onPageChange(newPage, newRowsPerPage);
    }
  };
  const [createDialogVisible, setCreateDialogVisible] = useState(false);
  const [editData, setEditData] = useState({});
  const { t } = useTranslation();
  const navigate = useNavigate();
  const templateBody = (rowData) => {
    return (
      <div className="flex  gap-1">
        <EditIcon
          onClick={() => {
            navigate("/manager/business/create", {
              state: { editData: rowData },
            });
          }}
          title={t("edit")}
        />
        <DeleteIcon
          onClick={() => {
            setConfirmationDialogVisible(true);
            setSelectedData(rowData);
          }}
          title={t("delete")}
        />
      </div>
    );
  };
  const sequenceBodyTemplate = (rowData, options) => {
    return options.rowIndex + 1 + (data?.page - 1) * data?.per_page;
  };

  const columnsData = [
    {
      body: templateBody,
      header: t("actions"),
    },
    {
      body: sequenceBodyTemplate,
      header: t("no"),
      style: { width: "3rem" },
    },
    {
      field: lang === "ar" ? "name_ar" : "name_en",
      header: t("name"),
    },
    {
      field: lang === "ar" ? "tpa_name_ar" : "tpa_name_en",
      header: t("TPAName"),
    },
    {
      field: "company_license",
      header: t("licenseNo"),
    },
    {
      field: lang === "ar" ? "city_ar" : "city_en",
      header: t("city"),
    },
    {
      field: "provider_code",
      header: t("provider_code"),
    },
    {
      field: "vat_no",
      header: t("vatNo"),
    },
    {
      field: "cr_no",
      header: t("crNo"),
    },
    {
      field: "contact_info",
      header: t("contact"),
    },
    {
      field: "address",
      header: t("address"),
    },
  ];

  const confirmDeleteHandler = () => {
    if (selectedData) {
      dispatch(deleteBuisness({ id: selectedData?.id })).then(() => {
        if (onRefresh) onRefresh();
      });
      setConfirmationDialogVisible(false);
      setSelectedData(null);
    }
  };

  return (
    <>
      <CustomTable
        data={data?.data}
        isLoading={loading}
        loadingIcon={<TableLoading />}
        columns={columnsData}
        rows={data?.per_page}
      />
      <ConfirmationModal
        message={`${t("do_you_really_want_to_delete_this_business")} "${lang === "ar" ? (selectedData?.data?.name_ar || selectedData?.name_ar) : (selectedData?.data?.name_en || selectedData?.name_en)}"?`}
        header={t("delete_confirmation")}
        Icon={FiTrash2}
        visible={confirmationDialogVisible}
        setVisible={setConfirmationDialogVisible}
        onAccept={confirmDeleteHandler}
        acceptLabel={t("delete")}
        rejectLabel={t("cancel")}
      />
      <BusinessModal
        setCreateDialogVisible={setCreateDialogVisible}
        createDialogVisible={createDialogVisible}
        editData={editData}
      />
      {data?.data?.length > 0 && (
        <CustomPagination
          currentPage={data?.page}
          rowsPerPage={data?.per_page}
          totalRecords={data?.total_pages}
          totalRecord={data?.total_record}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
}
